import { ArrowBack } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router";
import CustomField from "../../components/shared/CustomTextField";
import moment from "moment";
import { Button, Chip, Divider } from "@mui/material";
import { useEffect, useState } from "react";

import {
  getCategory,
  getDocument,
  getOrder,
  getSchoolGroup,
  getStudentImage,
} from "../../utils/API/schoolMethods";
import { basePort, baseUrl, docType, endpoints } from "../../utils/config";
import { getToken } from "../../utils/API/authMethods";
import { useStore } from "../../hooks/store";
import OrderForm from "../../components/Form/OrderForm";
import DriverPrepareForm from "../../components/Form/SchoolForm/DriverPrepareForm";
import GAITheoryDeclaration from "../../components/Form/SchoolForm/GAITheoryDeclaration";
import { usePortal } from "../../hooks/usePortal";
import { orderStatus } from "../../utils/API/api-utils";

export default function OrderPage() {
  const { state } = useLocation();
  const { orderId } = useParams();
  const portal = usePortal();
  const nav = useNavigate();
  // const { orderData, groupData } = state;
  const [pageState, setPageState] = useState({
    imageList: [],
    groupData: null,
    orderData: { id: null, status: null, categories: [] },
  });
  const store = useStore();

  console.log(pageState.orderData);

  useEffect(() => {
    portal.setPortal();
    getOrder(null, null, orderId).then(({ data, status }) => {
      if (status !== 200 && status !== 401 && status !== 426) {
        nav(-1);
        store.setAlert("Ошибка получения данных заявки", "error");
        portal.closePortal();
      } else {
        Promise.all([
          getStudentImage(data[0].user_id),
          getSchoolGroup("1"),
        ]).then(([imgRes, groupRes]) => {
          const finalPageState = { ...pageState, orderData: data[0] };
          if (imgRes.status === 200) {
            finalPageState.imageList = imgRes.data;
          }
          if (groupRes.status === 200) {
            finalPageState.groupData = groupRes.data;
          }
          setPageState(finalPageState);
          console.log(pageState);
          portal.closePortal();
        });
        // getStudentImage(orderData.user_id).then(({ data, status }) => {
        //   if (status === 200) {
        //     setImageList(data);
        //   }
        // });
      }
    });

    // getStudentImage(orderData.user_id).then(({ data, status }) => {
    //   if (status === 200) {
    //     setImageList(data);
    //   }
    // });
  }, []);

  const handleNavBack = () => nav("/school");
  const handleChangeStatusUpen = () => {
    store.setForm(<OrderForm />, new Function(), {
      id: pageState.orderData.id,
      status: pageState.orderData.status,
      reply_to_user: "",
      groupData: pageState.groupData,
    });
  };

  const handleStudyDoc = () => {
    store.setForm(<DriverPrepareForm />, null, {
      getDoc: (group, price, hour) => {
        window.location.replace(
          getDocument(
            docType.study,
            pageState.orderData.id,
            price,
            hour,
            group,
          ),
        );
      },
    });
  };
  const handlePracticeDoc = () => {
    window.location.replace(
      getDocument(docType.practice, pageState.orderData.id),
    );
  };
  const handleStudentAnceta = () => {
    window.location.replace(
      getDocument(docType.anceta, pageState.orderData.id),
    );
  };
  const handleSecureData = () => {
    window.location.replace(
      getDocument(docType.secureData, pageState.orderData.id),
    );
  };
  const handleDriverCard = () => {
    window.location.replace(
      getDocument(docType.driverCard, pageState.orderData.id),
    );
  };
  const handleExamCard = () => {
    window.location.replace(
      getDocument(docType.GAIPractice, pageState.orderData.id),
    );
  };

  const handleGAITheoryDeclaration = () => {
    window.location.replace(
      getDocument(
        docType.GAITheoryDeclaration,
        pageState.orderData.id,
        null,
        null,
        null,
        null,
      ),
    );
    // store.setForm(<GAITheoryDeclaration />, null, {
    //   getDoc: (date) => {

    //   },
    // });
  };

  return portal.open ? (
    <></>
  ) : (
    <main
      style={{
        gap: "10px",
        display: "flex",
        flexDirection: "column",
        height: "auto",
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          padding: "12px 0",
          paddingBottom: 0,
          gap: 8,
        }}>
        <ArrowBack style={{ width: "50" }} onClick={handleNavBack} />
        <p>Заявка № {pageState.orderData.id} </p>
        <Divider orientation="vertical" flexItem />
        <p>
          Статуc:
          <Chip
            sx={{
              borderRadius: "8px",
              marginLeft: "8px",
            }}
            color={orderStatus[pageState.orderData.status || 0].color}
            label={orderStatus[pageState.orderData.status || 0].text}
          />
        </p>
        <Divider orientation="vertical" flexItem />
        <p>
          Категории:{" "}
          <strong>
            {pageState.orderData.categories.map((c) => c.name).join(", ")}
          </strong>
        </p>
        <Divider orientation="vertical" flexItem />
        {pageState.orderData.categories.find((c) => c.name === "B") && (
          <p>
            КПП(кат. B):{" "}
            <strong>
              {pageState.orderData.is_auto_gear ? "Автомат" : "Механика"}
            </strong>
          </p>
        )}
      </div>

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          gap: "5px",
          margin: "0 10px",
        }}>
        <CustomField
          fullWidth={false}
          label={"ФИО курсанта"}
          value={pageState.orderData.name}
        />
        <CustomField
          fullWidth={false}
          label={"Телефон"}
          value={pageState.orderData.phone}
        />
        <CustomField
          fullWidth={false}
          label={"Имеющиеся категории"}
          value={pageState.orderData.studied_category || "---"}
        />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr " }}>
        <div
          style={{
            borderRadius: 5,
            margin: 5,
            padding: 5,
            border: "1px solid #dedede",
          }}>
          <p>Паспортные данные</p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr ",

              columnGap: "10px",
            }}>
            <CustomField
              label={"Кем выдан пасспорт"}
              fullWidth={false}
              value={pageState.orderData.passport_issued_by}
            />
            <CustomField
              label={"Дата выдачи паспорта"}
              fullWidth={false}
              value={
                pageState.orderData.passport_issued_date
                  ? moment(pageState.orderData.passport_issued_date).format(
                      "LL",
                    )
                  : null
              }
            />

            <div style={{ display: "flex" }}>
              <CustomField
                sx={{ flex: 0.3 }}
                label={"Серия паспо"}
                fullWidth={false}
                value={pageState.orderData.passport_seria}
              />
              <CustomField
                sx={{ flex: 0.7 }}
                label={"Номер паспорта"}
                fullWidth={false}
                value={pageState.orderData.passport_number}
              />
            </div>
            <CustomField
              label={"Адрес прописки"}
              fullWidth={false}
              value={pageState.orderData.registration_adres}
            />
            <CustomField
              label={"Адрес проживания"}
              fullWidth={false}
              value={pageState.orderData.living_adres}
            />
            <CustomField
              label={"Место работы"}
              fullWidth={false}
              value={pageState.orderData.work_adres}
            />
          </div>
        </div>
        <div
          style={{
            borderRadius: 5,
            margin: 5,
            padding: 5,
            border: "1px solid #dedede",
          }}>
          <p>Мед. справка</p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr ",
              columnGap: "10px",
            }}>
            <CustomField
              label={"Кем выдана мед.справка"}
              fullWidth={false}
              value={pageState.orderData.med_cert_issued_by}
            />
            <CustomField
              label={"Дата выдачи  мед.справки"}
              fullWidth={false}
              value={
                pageState.orderData.med_cert_issued_date
                  ? moment(pageState.orderData.med_cert_issued_date).format(
                      "LL",
                    )
                  : null
              }
            />

            <CustomField
              sx={{ flex: 0.7 }}
              label={"Номер мед. справки"}
              fullWidth={false}
              value={pageState.orderData.med_cert_number}
            />
          </div>
        </div>
      </div>
      {(pageState.orderData.status && (
        <CustomField
          multiline
          rows={2}
          label={"Ответ автошколы"}
          fullWidth={false}
          value={pageState.orderData.reply_to_user}
        />
      )) ||
        null}
      <Button
        sx={{
          width: "fit-content",
          marginBottom: "20px",
          marginLeft: "auto",
          marginRight: "20px",
        }}
        onClick={handleChangeStatusUpen}
        size="small"
        variant="contained">
        Изменить статус
      </Button>
      <div
        style={{
          borderRadius: 5,
          margin: 5,
          padding: 5,
          border: "1px solid #dedede",
          display: "flex",
          //   alignItems: "center",
          flexDirection: "column",
          gap: 5,
        }}>
        <div style={{ gap: 5, display: "flex", flexDirection: "column" }}>
          <p>Документы автошколы</p>
          <div style={{ gap: 5, display: "flex" }}>
            <Button variant="outlined" size="small" onClick={handleStudyDoc}>
              Договор на подготовку
            </Button>
            <Button variant="outlined" size="small" onClick={handlePracticeDoc}>
              Договор на практическое вождение
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleStudentAnceta}>
              Договор на зачисление
            </Button>
            <Button variant="outlined" size="small" onClick={handleSecureData}>
              Согласие обработки ПД
            </Button>
          </div>
          <p>Документы в гаи</p>
          <div style={{ gap: 5, display: "flex" }}>
            <Button variant="outlined" size="small" onClick={handleDriverCard}>
              Карточка водителя
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleGAITheoryDeclaration}>
              Заявление в ГАИ
            </Button>
            <Button variant="outlined" size="small" onClick={handleExamCard}>
              Экзаменационные карточки
            </Button>
          </div>
        </div>
      </div>
      <div
        // style={{
        //   borderRadius: 5,
        //   margin: 5,
        //   padding: 5,
        //   border: "1px solid #dedede",
        //   display: "flex",
        //   flex: 1,
        //   flexDirection: "column",
        //   gap: 5,
        // }}
        style={{
          display: " flex",

          flexDirection: " column",
          borderRadius: " 5px",
          gap: " 10px",
          padding: " 15px",
          minHeight: " 250px",
          margin: "5px",
          backgrounCcolor: " #fff",
          border: " 1px solid #dedede",
        }}>
        <p>Фотографии документов</p>

        {pageState.imageList.length !== 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
              gridTemplateRows: "1fr 1fr",
              alignContent: "center",
              justifyContent: "center",
            }}>
            {pageState.imageList.map(({ name }) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "0 auto",
                  width: "95%",
                }}>
                <a
                  target="_blank"
                  alt={name}
                  rel="noreferrer"
                  href={
                    baseUrl + "/image/student_file/" + name
                    // +
                    // "?jwt=" +
                    // getToken()
                  }>
                  <img
                    style={{
                      width: "100%",
                      height: "calc(auto - 32px)",
                      aspectRatio: "16 / 9",
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "10px",
                      boxSizing: "border-box",
                      border: "3px solid #dedede",
                      boxShadow: "0 3px 15px 0 rgba(0, 0, 0, .3)",
                    }}
                    // style={{
                    //   flex: 1,
                    //   display: "flex",
                    //   aspectRatio: "4 / 3 ",
                    //   height: "auto",
                    // }}
                    alt=""
                    src={
                      baseUrl +
                      "/image/student_file/" +
                      name +
                      "?jwt=" +
                      getToken()
                    }
                  />
                </a>
              </div>
            ))}
          </div>
        ) : (
          <p
            style={{
              alignSelf: "center",
              justifySelf: "center",
              margin: "auto",
            }}>
            Фото не добавлены
          </p>
        )}
      </div>
    </main>
  );
}
